import Appsignal from "@appsignal/javascript";
import { plugin } from "@appsignal/plugin-window-events"

let frontendAPIKey = document.querySelector('meta[name="appsignal_frontend_api_key"]')?.content
let revision = document.querySelector('meta[name="revision"]')?.content

export const appsignal = new Appsignal({
  key: frontendAPIKey,
  revision: revision
});

appsignal.use(plugin({
  onerror: true,
  onunhandledrejection: true
}))
